Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        })
    }
}

export function HuiInputRadio() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            ngValue: '<',
            disabled: '<',
            hName: '@',
            onChange: '&'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                <label class="hui hui-input hui-input-radio"
                       role="radio"
                       tabindex="0"
                       aria-labelledby="radio-input"
                       aria-checked="{{ $huiCtrl.ngModel ===  $huiCtrl.ngValue ? true : false}}"
                       ng-class="{ 'disabled': $huiCtrl.disabled }">
                        <input 
                            type="radio"
                            name="{{$huiCtrl.hName}}"
                            ng-disabled="$huiCtrl.disabled"
                            ng-value="$huiCtrl.ngValue"
                            ng-model="$huiCtrl.ngModel"
                            ng-change="$huiCtrl.handleChange($event)">
                        <span class="radio-circle" ng-class="{ 'radio-checked': ($huiCtrl.ngModel === $huiCtrl.ngValue) }">
                           <span class="radio-fill"></span>
                        </span>
                        <span ng-transclude></span>
                </label>
            `;
        }
    };
}